import * as React from 'react';
import { SVGProps } from 'react';

const IconFractureBlueSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.96 2.28a1 1 0 1 0-1.92-.56l-3.5 12a1 1 0 0 0 1.92.56l1.39-4.765c.56.02 1.086.06 1.571.113.875.093 1.622.227 2.22.36.548.122.971.243 1.255.332a8.959 8.959 0 0 1 .397.136l.018.007.003.001a.5.5 0 0 0 .372-.928L14.5 10l.186-.464h-.002l-.002-.002-.008-.003-.026-.01a9.734 9.734 0 0 0-.451-.154c-.31-.098-.76-.227-1.339-.355a21.994 21.994 0 0 0-3.72-.485L10.96 2.28Z"
      fill="var(--color-typo-normal)"
    />
  </svg>
);
export default IconFractureBlueSizeS;
